import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const AboutSection: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        backgroundColor: '#1a1a1a',
        color: 'white',
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: '900px', mx: 'auto' }}>
          {/* Section Title */}
          <Typography
            variant="h2"
            sx={{
              color: 'white',
              mb: 6,
              textAlign: 'center',
              fontSize: { xs: '2.5rem', md: '3.5rem' },
            }}
          >
            PROPELLING YOUR DIGITAL PRODUCTS TO NEW HEIGHTS
          </Typography>

          {/* Hero Image */}
          <Box
            sx={{
              width: '100%',
              mb: 6,
              overflow: 'hidden',
            }}
          >
            <img
              src="/about-image.jpg"
              alt="Kevyn Franco Speaking"
              width="899"
              height="430"
              loading="lazy"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
              }}
              onError={(e: any) => {
                e.target.style.display = 'none';
                e.target.parentElement.style.backgroundColor = '#333';
                e.target.parentElement.style.minHeight = '400px';
              }}
            />
          </Box>

          {/* Description Paragraphs */}
          <Typography
            variant="body1"
            sx={{
              mb: 4,
              fontSize: { xs: '1rem', md: '1.125rem' },
              lineHeight: 1.8,
            }}
          >
            I'm an AI Architect & Senior Software Engineer. I design and build production AI systems
            for startups — RAG pipelines, LLM integrations, and intelligent agents using FastAPI,
            LangChain, and cloud infrastructure.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 4,
              fontSize: { xs: '1rem', md: '1.125rem' },
              lineHeight: 1.8,
            }}
          >
            My recent work includes document processing systems that reduced workloads by 85%,
            microservices architectures that scaled 10x traffic without downtime, and AI knowledge
            bases for Series B fintechs. I help companies bridge traditional software development
            with the new world of intelligent, scalable products.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 6,
              fontSize: { xs: '1rem', md: '1.125rem' },
              lineHeight: 1.8,
            }}
          >
            I work as an independent AI architect from Peru, timezone-compatible with US teams.
            I also speak at conferences across Latin America about production AI systems and scalable
            Python architectures. My expertise spans Python, JavaScript, AI/ML systems, and cloud
            infrastructure — the perfect combination for building modern, scalable products.
          </Typography>

          {/* CTA Button */}
          <Box sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              onClick={() => navigate('/about')}
              endIcon={<ArrowForwardIcon />}
              sx={{
                backgroundColor: 'white',
                color: '#1a1a1a',
                px: 4,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 700,
                '&:hover': {
                  backgroundColor: '#f0f0f0',
                },
              }}
            >
              Read My Engineering Journey
            </Button>
          </Box>

          {/* Signature */}
          <Box
            sx={{
              mt: 8,
              textAlign: 'right',
            }}
          >
            <img
              src="/signature.svg"
              alt="Kevyn Signature"
              width="200"
              height="60"
              loading="lazy"
              style={{
                height: '60px',
                width: 'auto',
                filter: 'invert(1)',
              }}
              onError={(e: any) => {
                e.target.style.display = 'none';
                const parent = e.target.parentElement;
                parent.innerHTML = '<span style="font-family: cursive; font-size: 3rem; color: white;">Kevyn</span>';
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutSection;